module.exports = __webpack_public_path__ + "img/sprinkle-21.c68300e0.jpg";